// extracted by mini-css-extract-plugin
export default {"darkContentSection":"ckPbE___darkContentSection-module__darkContentSection"};